import React, { useState } from "react";
import { Row, Col, Typography, Input, Button, Form, Card, message } from "antd";
import { ReloadOutlined } from "@ant-design/icons";
import "./HasarIhbarKaskoPage.css";
import { useNavigate } from "react-router-dom";
import { useHasar } from "./HasarContext";
import getConfig from "./config";
import { useApiLogger } from "./hooks/useUIEventLogger";

// Set global message config for position
message.config({
    top: 24,
    right: 24,
    duration: 3,
    maxCount: 3,
});

const { Title } = Typography;

function HasarIhbarKaskoPage() {
    const [captcha1, setCaptcha1] = useState(Math.floor(Math.random() * 10) + 1);
    const [captcha2, setCaptcha2] = useState(Math.floor(Math.random() * 10) + 1);
    const [loading, setLoading] = useState(false);
    const [form] = Form.useForm();
    const navigate = useNavigate();
    const { setToken, setPlaka, setPoliceNo } = useHasar();

    // UI Event Logging
    //usePageViewLogger('KASKO_IHBAR_PAGE', { pageType: 'form' });
    //const { logFormStart, logFormSubmit, logFormError, logValidationError } = useFormLogger('KASKO_IHBAR_FORM');
    const { logApiCall, logApiSuccess, logApiError } = useApiLogger();

    //useEffect(() => {
    //    logFormStart();
    //}, [logFormStart]);

    const handleReloadCaptcha = () => {
        setCaptcha1(Math.floor(Math.random() * 10) + 1);
        setCaptcha2(Math.floor(Math.random() * 10) + 1);
        form.setFieldsValue({ captchaInput: "" });
    };

    const handleSubmit = async (values) => {
        const captchaResult = Number(values.captchaInput);
        if (captchaResult !== captcha1 + captcha2) {
            message.error("Güvenlik kodu hatalı. Lütfen doğru toplamı giriniz.");
            //logValidationError('captcha', 'Güvenlik kodu hatalı');
            return;
        }
        handleReloadCaptcha();

        // API çağrısı için body'yi uygun şekilde oluştur
        const body = {
            CariPoliceNo: values.policeNo,
            Aciklama: values.plaka // plaka -> aciklama
        };

        setLoading(true);
        const config = getConfig();
        const endpoint = `${config.apiBaseUrl}/Hasar/PoliceVarlikKontrol`;
        const callId = logApiCall(endpoint, 'POST', {
            formType: 'KASKO_IHBAR_POLICE_SORGULAMA'
        });

        try {
            const response = await fetch(endpoint, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(body)
            });

            if (response.ok) {
                const data = await response.json();
                setToken(data.token);
                setPoliceNo(values.policeNo);
                setPlaka(values.plaka);

                logApiSuccess(callId, endpoint, {
                    success: true,
                    nextPage: '/kasko/ihbar',
                    request: JSON.stringify(body),
                    response: data
                });
                navigate("/kasko/ihbar");
            } else {
                message.error("Girilen bilgiler hatalıdır. Lütfen kontrol ediniz. " + callId);
                logApiError(callId, endpoint, "Girilen bilgiler hatalı", response.status, {
                    success: false,
                    request: JSON.stringify(body),
                    response: data
                });
                //logFormError("API validation failed");
            }
        } catch (error) {
            message.error("Bir hata oluştu. Lütfen tekrar deneyiniz. " + callId);
            logApiError(callId, endpoint, error.message || "Network error", {
                success: false,
                request: JSON.stringify(body),
                error: error
            });

            //logFormError("Network error occurred");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="kasko-container">
            <div className="kasko-header">
                <Row gutter={[16, 16]} align="middle">
                    <Col xs={24} md={12}>
                        <Title level={1} className="kasko-title">Hasar İhbarı Kasko</Title>
                    </Col>
                    <Col xs={24} md={12} className="kasko-image-col">
                        <div className="kasko-image-wrapper">
                            <svg width="140" height="140" viewBox="0 0 140 140" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fillRule="evenodd" clipRule="evenodd" d="M140 70C140 108.66 108.66 140 70 140C31.34 140 0 108.66 0 70C0 31.34 31.34 0 70 0C108.66 0 140 31.34 140 70Z" fill="#DDE4E3"></path>
                                <path d="M106.07 71.68H33.93V50.2C33.96 42.26 40.42 35.84 48.36 35.87H91.64C99.58 35.84 106.04 42.26 106.07 50.2V71.68Z" fill="#91BFE3"></path>
                                <path d="M106.83 72.44H33.17V50.2C33.21 41.84 40 35.1 48.36 35.12H91.64C100 35.1 106.79 41.84 106.83 50.2V72.44ZM34.68 70.93H105.32V50.2C105.28 42.68 99.16 36.6 91.64 36.62H48.36C40.84 36.6 34.72 42.68 34.68 50.2V70.93Z" fill="#5495CF"></path>
                                <path d="M42 89.9H26.71C25.67 89.9 24.83 90.75 24.83 91.79V99.79C24.78 105.06 29.01 109.37 34.27 109.42H34.48C39.75 109.37 43.97 105.06 43.93 99.79V91.79C43.93 90.75 43.08 89.9 42.04 89.9C42.03 89.9 42.01 89.9 42 89.9Z" fill="#2167AE"></path>
                                <path d="M113.29 89.9H98.29C97.25 89.9 96.4 90.75 96.4 91.79V99.79C96.31 105 100.45 109.31 105.66 109.42H105.87C111.08 109.31 115.21 105 115.12 99.79V91.79C115.12 90.77 114.31 89.93 113.29 89.9Z" fill="#2167AE"></path>
                                <path d="M108 63.09V62.82H113.33C114.37 62.74 115.15 61.84 115.08 60.8C115.01 59.86 114.27 59.12 113.33 59.05H108V50.2C107.96 41.21 100.63 33.96 91.64 34H48.36C39.37 33.96 32.04 41.21 32 50.2V59.05H26.71C25.67 59.13 24.89 60.03 24.96 61.07C25.03 62.01 25.77 62.75 26.71 62.82H32V63.09C27.58 65.78 24.85 70.55 24.79 75.73V92.42C24.79 93.46 25.63 94.3 26.67 94.3H113.25C114.29 94.3 115.13 93.46 115.13 92.42V75.73C115.09 70.57 112.39 65.8 108 63.09ZM35.81 50.2C35.85 43.3 41.46 37.74 48.36 37.76H91.64C98.54 37.74 104.15 43.3 104.19 50.2V61.35C102.47 60.79 100.67 60.5 98.86 60.5H41.14C39.33 60.5 37.53 60.79 35.81 61.35V50.2Z" fill="#5495CF"></path>
                                <path d="M39.75 67.66C35.41 67.61 31.85 71.09 31.8 75.43C31.75 79.77 35.23 83.33 39.57 83.38C43.91 83.43 47.47 79.95 47.52 75.61C47.52 75.58 47.52 75.55 47.52 75.52C47.54 71.2 44.06 67.69 39.75 67.66Z" fill="#ECEEEF"></path>
                                <path d="M100.21 67.94C95.95 67.9 92.45 71.32 92.41 75.58C92.37 79.84 95.79 83.34 100.05 83.38C104.31 83.42 107.81 80 107.85 75.74C107.85 75.71 107.85 75.68 107.85 75.65C107.87 71.41 104.45 67.96 100.21 67.94Z" fill="#ECEEEF"></path>
                                <path d="M79.94 76.46H60.06C59.15 76.53 58.35 75.85 58.28 74.93C58.21 74.02 58.89 73.22 59.81 73.15C59.9 73.15 59.98 73.15 60.07 73.15H79.95C80.86 73.08 81.66 73.76 81.73 74.68C81.8 75.6 81.12 76.39 80.2 76.46C80.11 76.46 80.03 76.46 79.94 76.46Z" fill="#2167AE"></path>
                                <path d="M79.94 83.14H60.06C59.15 83.21 58.35 82.53 58.28 81.61C58.21 80.7 58.89 79.9 59.81 79.83C59.9 79.83 59.98 79.83 60.07 79.83H79.95C80.86 79.76 81.66 80.44 81.73 81.36C81.8 82.28 81.12 83.07 80.2 83.14C80.11 83.14 80.03 83.14 79.94 83.14Z" fill="#2167AE"></path>
                            </svg>
                        </div>
                    </Col>
                </Row>
            </div>
            <div className="kasko-form-wrapper">
                <Card className="kasko-form-card" bordered={false}>
                    <Form
                        form={form}
                        layout="vertical"
                        onFinish={handleSubmit}
                        autoComplete="off"
                    >
                        <Form.Item
                            name="policeNo"
                            rules={[
                                { required: true, message: "Poliçe Numarası giriniz" },
                                { pattern: /^[0-9]+$/, message: "Sadece rakam giriniz" }
                            ]}
                        >
                            <Input
                                size="large"
                                placeholder="Poliçe Numarası"
                                inputMode="numeric"
                                pattern="[0-9]*"
                                maxLength={20}
                            />
                        </Form.Item>
                        <Form.Item
                            name="plaka"
                            rules={[{ required: true, message: "Sigortalı Plaka giriniz" }]}
                        >
                            <Input
                                size="large"
                                placeholder="Sigortalı Plaka"
                                onChange={e => {
                                    const upperValue = e.target.value.toUpperCase();
                                    form.setFieldsValue({ plaka: upperValue });
                                }}
                            />
                        </Form.Item>
                        <div className="kasko-captcha-label">GÜVENLİK KODU</div>
                        <div className="kasko-captcha-row">
                            <div className="kasko-captcha-box">
                                <span className="kasko-captcha-text">{captcha1} + {captcha2} = ?</span>
                                <Button
                                    type="text"
                                    icon={<ReloadOutlined />}
                                    onClick={handleReloadCaptcha}
                                    className="kasko-captcha-reload"
                                />
                            </div>
                            <Form.Item
                                name="captchaInput"
                                rules={[{ required: true, message: "Güvenlik Kodunu giriniz" }]}
                                style={{ marginBottom: 0 }}
                            >
                                <Input
                                    size="large"
                                    className="kasko-captcha-input"
                                    placeholder="Toplam"
                                    inputMode="numeric"
                                    pattern="[0-9]*"
                                />
                            </Form.Item>
                        </div>
                        <Form.Item>
                            <Button type="primary" htmlType="submit" size="large" block loading={loading}>
                                SORGULA
                            </Button>
                        </Form.Item>
                    </Form>
                </Card>
            </div>
        </div>
    );
}

export default HasarIhbarKaskoPage;
